<template>
  <div
    v-if="!mounted"
    v-html="generateHTML(props.value, extensions)"
    :class="{ partial: partial }"
  />
  <editor-content v-else :editor="editor" :class="{ partial: partial }" />
</template>

<script setup lang="ts">
import { useEditor, EditorContent } from "@tiptap/vue-3";
import StarterKit from "@tiptap/starter-kit";
import { generateHTML } from "@tiptap/html";
import Image, { useHandleDrop } from "@/nodes/Image";
import Link from "@tiptap/extension-link";

const extensions = [StarterKit, Image, Link];
const props = defineProps<{
  value: any;
  partial?: boolean;
}>();

const emit = defineEmits(["update:modelValue"]);
const mounted = ref(false);
//onMounted(() => (mounted.value = true));

const editor = useEditor({
  content: props.value,
  extensions,
  editable: false,
});
</script>
<style scoped>
.partial > :deep(*) {
  display: block;
}
</style>
